<template>
  <div class="supplier">
    <Button
      class="add-button"
      type="primary"
      icon="md-add"
      size="large"
      @click="add"
    >
      添加渠道
    </Button>
    <Form
      ref="supplierForm"
      :model="editSupplier"
      :rules="rules"
    >
      <Table
        :columns="columns"
        :data="supplierList"
        size="large"
        stripe
      >
        <template
          slot="name"
          slot-scope="{ row: { id, supplier_name } }"
        >
          <FormItem
            v-if="editId === id"
            class="form-item"
            prop="supplier_name"
          >
            <Input
              v-model="editSupplier.supplier_name"
              size="large"
              :autofocus="true"
            />
          </FormItem>
          <p
            v-else
            v-text="supplier_name"
          />
        </template>
        <template
          slot="status"
          slot-scope="{ row: { id, status } }"
        >
          <iSwitch
            v-if="editId === id"
            v-model="editSupplier.status"
            size="large"
            :true-value="1"
            :false-value="0"
          >
            <span slot="open">
              打开
            </span>
            <span slot="close">
              关闭
            </span>
          </iSwitch>
          <p
            v-else
            v-text="status ? '打开' : '关闭'"
          />
        </template>
        <template
          slot="edit"
          slot-scope="{ row }"
        >
          <div v-if="editId === row.id">
            <Button
              v-if="row.id"
              class="operation"
              type="primary"
              icon="md-checkmark"
              @click="submitEdit"
            />
            <Button
              v-else
              class="operation"
              type="primary"
              icon="md-checkmark"
              @click="submitAdd"
            />
            <Button
              v-if="row.id"
              class="operation"
              icon="md-close"
              @click="cancelEdit"
            />
            <Button
              v-else
              class="operation"
              icon="md-trash"
              @click="cancelAdd"
            />
            <Poptip
              confirm
              transfer
              title="确定要删除吗？"
              ok-text="删除"
              cancel-text="取消"
              @on-ok="deleteSupplier({ supplier: row })"
            >
              <Button
                v-if="row.id"
                class="operation delete"
                type="error"
                icon="md-trash"
              />
            </Poptip>
          </div>
          <div v-else>
            <Button
              class="operation"
              icon="md-create"
              @click="edit({ supplier: Object.assign({}, row) })"
            />
          </div>
        </template>
      </Table>
    </Form>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { Table, Button, Input, Switch, Form, FormItem, Poptip } from 'iview'

export default {
  components: {
    Table,
    Button,
    Input,
    iSwitch: Switch,
    Form,
    FormItem,
    Poptip
  },

  data () {
    return {
      columns: [
        { title: '渠道ID', key: 'id', width: 80 },
        { title: '渠道名', slot: 'name' },
        { title: '状态', slot: 'status' },
        { title: '操作', slot: 'edit', width: 160 }
      ],
      rules: {
        supplier_name: [
          { required: true, message: '请填写渠道名称' }
        ]
      }
    }
  },

  computed: {
    ...mapState('supplier', [
      'supplierList',
      'total',
      'current',
      'editId',
      'editSupplier'
    ])
  },

  created () {
    this.getAllSupplier()
  },

  methods: {
    ...mapMutations('supplier', [
      'add',
      'cancelAdd',
      'edit',
      'cancelEdit'
    ]),

    ...mapActions('supplier', {
      getAllSupplier: 'getAll',
      deleteSupplier: 'delete',

      submitAdd (dispatch) {
        this.$refs.supplierForm.validate(isValid => {
          if (isValid) {
            dispatch('submitAdd')
          } else {
            this.$Message.error('填写信息有误！')
          }
        })
      },

      submitEdit (dispatch) {
        this.$refs.supplierForm.validate(isValid => {
          if (isValid) {
            dispatch('submitEdit')
          } else {
            this.$Message.error('填写信息有误！')
          }
        })
      }
    })
  }
}
</script>

<style lang="less" scoped>
.add-button {
  margin-bottom: 10px;
}
button.operation {
  margin-right: 5px;
  padding: 0;
  width: 33px;
  height: 33px;
  font-size: 16px;

  &:last-child {
    margin-right: 0;
  }

  &.delete {
    margin-left: 15px;
  }
}
.form-item {
  margin-top: 24px;
}
</style>
